import { render } from "./IncomeProtectionExpressQuestion.vue?vue&type=template&id=eac75d72&scoped=true"
import script from "./IncomeProtectionExpressQuestion.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionExpressQuestion.vue?vue&type=script&lang=js"

import "./IncomeProtectionExpressQuestion.vue?vue&type=style&index=0&id=eac75d72&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac75d72"]])

export default __exports__